export default "__VITE_ASSET__BCiROccZ__"